import { useEffect } from 'react';

import styled from '@emotion/styled';

import { useTheme, Grid } from '@mui/material';

import { formatCurrency } from '../../../utils/util';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import  useIsMobile from '../../../hooks/useIsMobile';

import { useQuery } from '@tanstack/react-query';

import { getVendorById } from '../../Vendors/apiService';

const Container = styled.div`
  /* width: 20rem; */
  /* max-width: 98%; */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const StatContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 8rem;
  border: 2px dashed ${props => props.$color ? props.$color : props.theme.colors.border};
  border-radius: 8px;
  gap: .6rem;
`;

const ReceivedTitle = styled.div`
  text-transform: uppercase;
  font-weight: 500;
  color: ${props => props.theme.colors.lightText};
  font-size: 1.3rem;
`;

const ReceivedAmount = styled.div`
  font-size: 2.2rem;
  width: fit-content;
`;

const BalanceTitle = styled.div`
  color: ${props => props.$color};
`;

const BalanceAmount = styled.div`
  /* background-color: ${props => props.$bg}; */
  color: ${props => props.$color};
  padding: .5rem;
  border-radius: 5px;
  font-weight: 500;
  width: fit-content;
`;

const BalanceInfo = ({ }) => {
  const theme = useTheme();
  const { isMobile } = useIsMobile();


  const { values } = useFormikContext() || {};
  const { formValues, setFormValues } = useFormData() || {};

  const { data: vendor } = useQuery({
    queryKey: ['vendor', values?.vendor_id],
    queryFn: () => getVendorById(values?.vendor_id),
    enabled: !!values?.vendor_id,
  })


  useEffect(() => {
    if (vendor) {
      setFormValues(ofv => ({ ...ofv, final_balance: vendor.balance }));
    }
  }, [vendor]);

  if (!isMobile) return null;

  // console.log(values, formValues);

  let balance = formValues?.final_balance || 0;
  let amount = values?.amount || 0;

  let balBg, balColor;
  if (balance > 0) {
    if (amount === 0) {
      balBg = theme.palette.error.light;
      balColor = theme.palette.error.main;
    } else if (amount < balance) {
      balBg = theme.palette.warning.light;
      balColor = theme.palette.warning.main;
    } else {
      balBg = theme.palette.success.light;
      balColor = theme.palette.success.main;
    }
  } else {
    balBg = theme.palette.success.light;
    balColor = theme.palette.success.main;
  }

  return (
    <Grid size={{xs: 12}}>
      <Container>
        <StatContainer>
          <ReceivedTitle>Amount Received:</ReceivedTitle>
          <ReceivedAmount>{formatCurrency(amount)}</ReceivedAmount>
        </StatContainer>
        <StatContainer $color={balColor}>
          <BalanceTitle $color={balColor}>Vendor Balance:</BalanceTitle>
          <BalanceAmount $bg={balBg} $color={balColor}>{formatCurrency(balance)}</BalanceAmount>
        </StatContainer>
      </Container>
    </Grid>
  );
  
};

export default BalanceInfo;